export default __webpack_public_path__ + "static/media/logo-Einstein-Verifica.149c95d1.svg";